module.exports = __webpack_public_path__ + "b756f719296207a2c69e911f62d721eb.svg";